/** Toolbar icon buttons aligned to the evidence locker search field (54px tall). */
export const evidenceLockerToolbarIconButtonClassName = 'h-[54px] w-[54px] p-0';

/** Compact text actions in the locker header row (Clear All, Include All). */
export const evidenceLockerHeaderActionButtonClassName =
  'h-auto shrink-0 px-1 py-0';
